<i class="pi pi-spin pi-spinner text-lpprimary" style="font-size: 2rem"></i>
